import React from "react";

// import components
import { ReactComponent as OthlLogo } from "../../assets/othl/calcon-logo-white-2x.fa4e4317 (1).svg";

// import styled components
import { Spinner } from "../styled";
import { LoadingWrapper } from "./styled";

const Loading = () => (
  <LoadingWrapper>
    <Spinner height="200px" width="200px" />
    <h1>
      <em>Loading your branch...</em>
    </h1>
    <OthlLogo />
  </LoadingWrapper>
);

export default Loading;
